export default "__VITE_ASSET__cbe9981f__"